import { Button, Typography, Container } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import Page from '../components/Page';

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0)
}));

export default function Page404() {
  
  const { t } = useTranslation();

  return (
    <Page title="404 Page Not Found">
      <Container>
        <ContentStyle sx={{ textAlign: 'center', alignItems: 'center' }}>
          <Typography variant="h3" paragraph> {t('pageNotFound')}</Typography>
          <Typography sx={{ color: 'text.secondary' }}>{t('notFoundMsg')}</Typography>
          <Button to="/" size="large" variant="contained" component={RouterLink}>{t('goToHome')}</Button>
        </ContentStyle>
      </Container>
    </Page>
  );
}
